(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-bundle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-bundle-picker')) {
    class QuantityBundlePicker extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.variantInput = this.form.querySelector('input[name="id"]');
        this.productIdInput = this.form.querySelector('input[name="product-id"]');
        this.addButton = this.form.querySelector('[name="add"]');
        this.productInfo = this.closest('.product-info');
        this.priceValue = this.productInfo.querySelector('.product-info__price .price__current .js-value');
        this.unitSummary = this.productInfo.querySelector('.cs-per-sheet');
        if (this.unitSummary) this.unitSummary.hidden = true;
        this.addEventListener('change', this.handleChange.bind(this));
      }

      handleChange(event) {
        const input = event.target.closest('.quantity-bundle__input');
        if (!input) return;
        this.variantInput.value = input.dataset.variantId;
        this.productIdInput.value = input.dataset.productId;
        this.addButton.disabled = input.dataset.available !== 'true';
        this.priceValue.textContent = input.dataset.price;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('quantity-bundle-picker', QuantityBundlePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
